import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, EnvelopeIcon, MapPinIcon, ClockIcon } from '@heroicons/react/24/outline';
import Footer from '../components/Footer';
import Header from '../components/Header';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <Header />

      {/* Hero Section */}
      <div className="relative pt-32 pb-24 md:py-48 bg-gradient-to-r from-customBlueDark to-customBlueLight">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight"
          >
            Let's Start Your Financial Success Story
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-xl text-blue-100 max-w-3xl mx-auto"
          >
            Reach out to our expert team for personalized financial solutions and strategic guidance.
          </motion.p>
        </div>
      </div>

      {/* Contact Content */}
      <div className="container mx-auto px-4 lg:px-8 py-16 md:py-24">
        {/* Contact Channels */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-8 mb-24"
        >
          <div className="p-8 bg-white rounded-2xl shadow-lg text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <PhoneIcon className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold mb-4">Direct Communication</h3>
            <p className="text-gray-600 mb-4">Speak directly with our experts</p>
            <div className="space-y-2">
              <p className="text-blue-600 font-medium">+91 79847 53805</p>
              <p className="text-gray-600 text-sm"></p>
            </div>
          </div>

          <div className="p-8 bg-white rounded-2xl shadow-lg text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <EnvelopeIcon className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="text-xl font-semibold mb-4">Professional Correspondence</h3>
            <p className="text-gray-600 mb-4">For detailed inquiries and documents</p>
            <div className="space-y-2">
              <p className="text-blue-600 font-medium">hello@cmadevangpatel.com</p>
              
            </div>
          </div>

         
        </motion.div>

        {/* Office Network */}
        {/* <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mb-24"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
            Our Pan-India Presence
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h3 className="text-xl font-semibold mb-4 flex items-center">
                <MapPinIcon className="w-6 h-6 text-blue-600 mr-2" />
                Mumbai
              </h3>
              <p className="text-gray-600 mb-4">
                12th Floor, Tower A<br/>
                Financial Square, BKC<br/>
                Mumbai - 400051
              </p>
              <a href="#" className="text-blue-600 hover:text-blue-800 flex items-center">
                Get Directions →
              </a>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h3 className="text-xl font-semibold mb-4 flex items-center">
                <MapPinIcon className="w-6 h-6 text-blue-600 mr-2" />
                Delhi NCR
              </h3>
              <p className="text-gray-600 mb-4">
                Cyber City Tower<br/>
                Sector 15, Gurugram<br/>
                Haryana - 122001
              </p>
              <a href="#" className="text-blue-600 hover:text-blue-800 flex items-center">
                Get Directions →
              </a>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h3 className="text-xl font-semibold mb-4 flex items-center">
                <MapPinIcon className="w-6 h-6 text-blue-600 mr-2" />
                Bengaluru
              </h3>
              <p className="text-gray-600 mb-4">
                Tech Park Annex<br/>
                Outer Ring Road<br/>
                Bengaluru - 560103
              </p>
              <a href="#" className="text-blue-600 hover:text-blue-800 flex items-center">
                Get Directions →
              </a>
            </div>
          </div>
        </motion.div> */}

        {/* Operational Excellence */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-12 mb-24"
        >
           <div className="p-8 bg-white rounded-2xl shadow-lg text-center">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <MapPinIcon className="w-8 h-8 text-purple-600" />
            </div>
            <h3 className="text-xl font-semibold mb-4">Corporate Headquarters</h3>
            <p className="text-gray-600 mb-4">B1/802, Westgate Bussiness Bay, near Divya Bhaskar press, opp. Andjan party plot, S. G. Highway, Makarba, Ahmedabad, Gujarat, 380051</p>
            <div className="space-y-2">
              <p className="text-gray-600"></p>
              <p className="text-gray-600"></p>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <ClockIcon className="w-8 h-8 text-blue-600 mr-3" />
              Business Hours
            </h2>
            <div className="space-y-4">
              <div className="flex justify-between border-b pb-2">
                <span className="text-gray-600">Weekdays</span>
                <span className="font-medium">9:00 AM - 7:00 PM</span>
              </div>
              <div className="flex justify-between border-b pb-2">
                <span className="text-gray-600">Saturday</span>
                <span className="font-medium">10:00 AM - 4:00 PM</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Emergency Support</span>
                <span className="font-medium text-blue-600">24/7 Available</span>
              </div>
            </div>
          </div>

         
        </motion.div>

        {/* CTA Section */}
        <div className="bg-customBlueLight rounded-2xl p-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Begin Your Consultation Journey
          </h2>
          <p className="text-blue-100 text-xl mb-8 max-w-2xl mx-auto">
            Connect with our certified professionals through your preferred channel - 
            we're ready to discuss your financial objectives.
          </p>
          {/* <div className="flex justify-center space-x-6">
            <motion.a 
              whileHover={{ scale: 1.05 }}
              href="tel:+919876543210" 
              className="bg-white text-blue-700 py-4 px-8 rounded-xl font-semibold hover:bg-blue-50 transition-colors"
            >
              Call Now
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.05 }}
              href="mailto:consult@cafirm.com"
              className="border-2 border-white text-white py-4 px-8 rounded-xl font-semibold hover:bg-white/10 transition-colors"
            >
              Email Us
            </motion.a>
          </div> */}
        </div>
      </div>

      {/* Footer (Same as Previous Pages) */}
      <Footer />
    </div>
  );
};

export default ContactPage;